import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { Loader } from '../components';
import { NotFoundPage } from '../pages/not-found';

const UnicoPage = lazy(() =>
  import('../pages/biometrics/unico').then((module) => ({
    default: module.UnicoPage,
  })),
);

const CeaPage = lazy(() =>
  import('../pages/biometrics/cea').then((module) => ({
    default: module.CeaPage,
  })),
);

const PayfacePage = lazy(() =>
  import('../pages/biometrics/payface').then((module) => ({
    default: module.PayfacePage,
  })),
);

const router = createBrowserRouter([
  {
    path: '/unico',
    element: (
      <Suspense fallback={<Loader isVisible={true} />}>
        <UnicoPage />
      </Suspense>
    ),
  },
  {
    path: '/cea',
    element: (
      <Suspense fallback={<Loader isVisible={true} />}>
        <CeaPage />
      </Suspense>
    ),
  },
  {
    path: '/payface',
    element: (
      <Suspense fallback={<Loader isVisible={true} />}>
        <PayfacePage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export function AppRoutes() {
  return <RouterProvider router={router} />;
}
